import React, {useCallback, useRef, useState} from 'react';
import cx from 'classnames';
import {Tag} from '@priority-software/priority-style-react';
import {ModernTooltip} from '../../../../../../../../../components/Common/Tooltip/ModernTooltip';
import {ruleDialogID} from '../../../../../../../constants';
import {FONT_TOLERANCE, TAG_EMAIL_TOOLTIP_MAXWIDTH} from './constants';
import styles from './styles.module.scss';

type EmailTagProps = {
    maxWidth?: number;
    value: string;
    onRemove: (value: string) => void;
    isVisible: boolean;
};
export const EmailTag = (props: EmailTagProps) => {
    const {maxWidth, value, isVisible, onRemove} = props;
    const textRef = useRef<HTMLSpanElement>();
    const [show, setShow] = useState(false);

    const handleShow = useCallback((flag: boolean) => {
        if (flag) {
            const el = textRef.current;
            const isTruncated = el.offsetWidth + FONT_TOLERANCE < el.scrollWidth;
            if (isTruncated) {
                setShow(true);
            }
        } else {
            setShow(false);
        }
    }, []);

    return (
        <Tag
            style={{maxWidth: maxWidth || null}}
            key={value}
            onClose={() => onRemove(value)}
            componentClasses={cx(styles.tag, {
                [styles.tagVisible]: isVisible
            })}
        >
            <ModernTooltip
                show={show}
                toggleShow={handleShow}
                tooltip={
                    <div dir="ltr" className={styles.emailTooltip}>
                        {value}
                    </div>
                }
                arrowOffset={10}
                portalId={ruleDialogID}
                position="top"
                wrapperClassname={styles.ellipsisWrap}
                maxWidth={TAG_EMAIL_TOOLTIP_MAXWIDTH}
            >
                <span ref={textRef} className={styles.ellipsis}>
                    {value}
                </span>
            </ModernTooltip>
        </Tag>
    );
};
